import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Isotope from "isotope-layout";
import GLightbox from "glightbox";
import imagesLoaded from "imagesloaded";
import axios from "axios";
import Footer1 from "../navbar/Footer1";

const Projects = () => {
  const [categories, setCategories] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  // Fetch categories and projects
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        
        const categoriesResponse = await axios.get(
          "https://vogelkoparchitects.com/api/api/categories/"
        );
        setCategories(categoriesResponse.data);

        const projectsResponse = await axios.get(
          "https://vogelkoparchitects.com/api/api/projects/"
        );
        setProjects(projectsResponse.data);
        
        setLoading(false);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load projects. Please try again later.");
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  // Initialize Isotope after projects are loaded
  useEffect(() => {
    if (!loading && projects.length > 0) {
      const initIsotope = () => {
        let portfolioContainer = document.querySelector(".isotope-container");
        if (portfolioContainer) {
          let isotope = new Isotope(portfolioContainer, {
            itemSelector: ".portfolio-item",
            layoutMode: "masonry",
            percentPosition: true,
          });



          let portfolioFilters = document.querySelectorAll(
            ".portfolio-filters li"
          );

          portfolioFilters.forEach((filter) => {
            filter.addEventListener("click", function (e) {
              e.preventDefault();
              portfolioFilters.forEach((el) => {
                el.classList.remove("filter-active");
              });
              this.classList.add("filter-active");

              const filterValue = this.getAttribute("data-filter");
              isotope.arrange({ filter: filterValue });
            });
          });

          imagesLoaded(portfolioContainer, () => {
            isotope.layout();
          });
        }
      };

      setTimeout(initIsotope, 100);
    }
  }, [loading, projects]);

  // Initialize Lightbox
  useEffect(() => {
    if (!loading) {
      GLightbox({
        selector: ".glightbox",
        touchNavigation: true,
        loop: true,
        autoplayVideos: true,
      });
    }
  }, [loading]);

  const getFilterClass = (categoryTitle) => {
    const filterMap = {
      "residential": "filter-remodeling",
      "interior": "filter-construction",
      "commercial": "filter-design",
      "landscape": "filter-repairs",
      "projects": "filter-remodeling"
    };
    return filterMap[categoryTitle?.toLowerCase()] || "filter-remodeling";
  };

  // Truncate description
  const truncateDescription = (description, maxLength = 100) => {
    if (!description) return "";
    if (description.length <= maxLength) return description;
    return description.substring(0, maxLength) + "...";
  };

  if (loading) {
    return (
      <div className="projects-loading">
        <div className="projects-spinner"></div>
        <p>Loading projects...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="projects-error">
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div className="projects-page">
      {/* Hero Banner */}
      <div className="projects-hero">
        <div className="projects-hero-overlay"></div>
        <div className="projects-hero-content">
          <h1>Our Projects</h1>
          <p>Discover our collection of architectural masterpieces</p>
        </div>
      </div>

      {/* Projects Section */}
      <section className="projects-section">
        <div className="projects-container">
          {/* Category Filters */}
          <div className="projects-filters-wrapper">
            <ul className="projects-filters">
              <li data-filter="*" className="filter-active">All Projects</li>
              {categories.map((category) => (
                <li 
                  key={category.id} 
                  data-filter={`.${getFilterClass(category.title)}`}
                >
                  {category.title}
                </li>
              ))}
            </ul>
          </div>

          {/* Projects Grid */}
          <div className="projects-grid isotope-container">
            {projects.map((project) => (
              <div
                key={project.id}
                className={`projects-card portfolio-item ${getFilterClass(project.category?.title)}`}
              >
                <Link to={`/project-detail/${project.id}`} className="projects-card-link">
                  <div className="projects-card-image">
                    <img
                      src={project.image || "/placeholder.jpg"}
                      alt={project.title}
                      onError={(e) => {
                        e.target.src = "/placeholder.jpg";
                      }}
                    />
                    <div className="projects-card-overlay">
                      <div className="projects-card-overlay-content">
                        <span className="projects-view-btn">View Project</span>
                      </div>
                    </div>
                  </div>
                  <div className="projects-card-info">
                    <h3 className="projects-card-title">{project.title}</h3>
                    {project.description && (
                      <p className="projects-card-description">
                        {truncateDescription(project.description, 80)}
                      </p>
                    )}
                    <div className="projects-card-meta">
                      {project.category && (
                        <span className="projects-card-category">
                          {project.category.title}
                        </span>
                      )}
                      {project.location && (
                        <span className="projects-card-location">
                          {project.location}
                        </span>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer1 />
    </div>
  );
};

export default Projects;